import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import styles from './About.module.css';
import aboutImg from '../../assets/about.jpg';

const stats = [
  { value: 10, suffix: '+', label: 'Years Experience' },
  { value: 200, suffix: '+', label: 'Projects Completed' },
  { value: 100, suffix: '%', label: 'Client Satisfaction' },
  { value: 15, suffix: '+', label: 'Services Offered' },
];

export default function About() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section id="about" className={styles.section} ref={ref}>
      <div className={styles.container}>
        {/* Image side */}
        <motion.div
          className={styles.imgCol}
          initial={{ opacity: 0, x: -50 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.9 }}
        >
          <div className={styles.imgWrap}>
            <img src={aboutImg} alt="AussieSpec Structures" className={styles.img} />
            <div className={styles.imgAccent} />
          </div>
          {/* Incorporation badge */}
          <div className={styles.incBadge}>
            <span className={styles.incLabel}>BC Incorporated</span>
            <span className={styles.incNum}>BC1585120</span>
          </div>
          {/* Profile placeholder */}
          <div className={styles.profileCard}>
            <div className={styles.profileImg}>
              {/* TODO: Add Enes photo here */}
              <span>EC</span>
            </div>
            <div>
              <strong>Enes Calimli</strong>
              <p>Founder & Lead Contractor</p>
            </div>
          </div>
        </motion.div>

        {/* Text side */}
        <div className={styles.textCol}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.1 }}
          >
            <span className={styles.label}>
              <span className={styles.labelLine} />About Us
            </span>
            <h2 className={styles.heading}>
              Precision Built.<br />
              <span className={styles.accent}>Pride in Every Project.</span>
            </h2>
            <p className={styles.bio}>
              AussieSpec Structures is a fully incorporated BC construction company led by
              <strong> Enes Calimli</strong>, a skilled and experienced contractor with a
              hands-on approach to every job. Based in Vancouver, we serve residential and
              commercial clients throughout the Lower Mainland.
            </p>
            <p className={styles.bio}>
              From full renovations to precise framing, cladding systems, waterproofing, Hardie board
              installations, natural stone, stucco repairs and finishing carpentry — we bring
              trade-level expertise, reliability, and a commitment to quality that speaks for itself.
            </p>

            <div className={styles.highlights}>
              {[
                'Fully licensed & BC incorporated',
                'Residential & commercial projects',
                'Hardie board & cement board specialists',
                'Rainscreen & waterproofing systems',
                'Free estimates — no obligation',
                'Clean, on-time, professional service',
              ].map(h => (
                <div key={h} className={styles.highlight}>
                  <span className={styles.highlightIcon}>◆</span>
                  <span>{h}</span>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Stats */}
          <motion.div
            className={styles.stats}
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            {stats.map((s, i) => (
              <div key={s.label} className={styles.stat}>
                <span className={styles.statVal}>
                  {inView && <CountUp end={s.value} duration={2} delay={0.3 + i * 0.1} />}
                  {s.suffix}
                </span>
                <span className={styles.statLabel}>{s.label}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
